<template>
    <div class="checkin_main">
        <div class="head">
            <Tag class="btn" mark type="warning" plain size="large" @click="showrule=true">活动规则</Tag>
            <VanImage    :src="taskInfo.imgurl" width="100%" fit="fill"></VanImage>
        </div>
        <panel :title="taskInfo.title" :desc="desc">
            <cell-group :border="false">
                <cell center v-for="(item) in taskInfo['subList']" :is-link="taskbegin" :key="item.id"
                      :to="taskbegin?{name:'signinDetail',query:Object.assign({},params,{'id':item.id})}:''">
                    <van-image fit="cover" :src="item.icon" slot="icon" width="1.5rem" height="1.5rem" style="margin-right:10px;">
                    </van-image>
                    <div slot="title">
                        {{item.title}}
                        <tag color="#FF6A03" round v-if="item.playerInfo">已完成</tag>
                    </div>
                    <Tag type="danger" slot="label" v-if="!taskbegin">{{stateDesc}}</Tag>
                    <div slot="label" v-else>{{item.shortdesc}}</div>
                </cell>
            </cell-group>
        </panel>
        <van-dialog v-model="showrule" confirmButtonColor="#FF7B4E" confirmlButtonText="我知道了">
            <div class="block_body" v-html="taskInfo.intro"/>
        </van-dialog>
    </div>
</template>

<script>
    import {Cell, CellGroup, Tag, Image, Panel} from 'vant';

    export default {
        components: {
            Cell,
            CellGroup,
            Tag,
            VanImage: Image,
            Panel
        },
        computed:{
          desc:function(){
              return "活动时间:"+this.taskInfo.start_time_show+" 至 "+this.taskInfo.end_time_show;
          },
          taskbegin:function(){
                return this.systime>= this.taskInfo.start_time  &&  this.systime <= this.taskInfo.end_time
          },
          stateDesc:function(){
              if(this.systime<this.taskInfo.start_time){
                  return "活动未开始"
              }

              if(this.systime > this.taskInfo.end_time){
                  return "活动已结束"
              }
              return "";
          }
        },
        data() {
            return {
                activity_sub_id: '',
                params: this.$route.query,
                showrule: false,
                rule: '12345678900987654321',
                taskInfo: '',
                systime:''

            };
        },
        mounted() {
            // this.$wechat.jsAuthorize();
            this.$nextTick(() => {
                this.getTaskList();
            })
        },
        methods: {
            getTaskList() {
                this.$api.activity.taskList(this.params).then((res) => {
                    if (res.status * 1 === 200) {
                        let finished = 0;
                        if (res.data.subList.length) {
                            res.data.subList.forEach((item) => {
                                if (item.playerInfo != null) {
                                    finished++
                                }
                            })
                        }
                        res.data.finished = finished;
                        this.taskInfo = res.data
                        this.systime = res.timestamp
                    }
                })
            }
        }
    };
</script>

<style scoped>
    .head >>> .van-image {
        display: block;
    }
    @import "./index.less";
</style>




